<template>
	<div class="b-swr">
		<div class="b-swr-input">
			<div class="b-swr-input__wrapper">
				<label for="search" class="input input_search">
					<button
						@click="search"
						class="input__search-btn search-button"
					></button>
					<input
						v-model.trim="inputValue"
						@input="throttle(search)"
						@keydown.enter="search"
						id="search"
						type="search"
						placeholder="Например: расчет размера возмещения"
						name="search"
						class="input__field"
						autocomplete="off"
					/>
					<button
						@click="resetSearch"
						v-if="inputValue.length > 0"
						class="input__clear-btn"
						type="button"
					>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path d="M2 22L22 2" stroke="black" stroke-width="2"></path>
							<path d="M22 22L2 2" stroke="black" stroke-width="2"></path>
						</svg>
					</button>
				</label>
			</div>
		</div>
		<teleport to="#search-answer">
			<div v-if="curItem" class="b-swr-detail n-px-0">
				<a
					class="b-swr-detail__tag e-tag g-text__p _middle"
					:href="`${curItem.sectionCode}/`"
					>{{ curItem.sectionName }}</a
				>
				<p
					class="b-swr-detail__title g-h-20 g-h-m-16 _medium"
					v-html="curItem.title"
				/>
				<p
					class="b-swr-detail__descr g-text__p _gray"
					v-html="curItem.content"
				/>
				<div class="b-swr-detail__bottom">
					<div class="b-swr-detail__buttons">
						<a
							@click="sendTitleToParent(curItem)"
							href="#official"
							class="u-btn js-fancybox"
						>
							<span class="g-d-m-none"
								>Получить ответ на&nbsp;официальном бланке</span
							>
							<span class="g-d-m-block">Ответ на&nbsp;официальном бланке</span>
						</a>
						<share-button
							:link="getShareLink(curItem)"
							:share-title="curItem.title"
						></share-button>
					</div>
					<a
						class="u-link _inline g-text__p _medium"
						:href="`${curItem.sectionCode}/`"
					>
						<span>Все вопросы по программе </span>
						<span>{{ curItem.sectionName }}</span>
					</a>
				</div>
			</div>
		</teleport>
		<div class="b-swr-res">
			<Transition name="b-swr-fade">
				<template v-if="inputValue && !resultChecked">
					<div
						v-if="resultsList.length && searchStart"
						class="b-swr-res__container"
					>
						<div
							@click="showDetailItem(item)"
							v-for="(item, idx) in resultsList"
							:key="`res-${idx}`"
							class="b-swr-res__item"
						>
							<div
								v-html="item.title"
								class="b-swr-res__title g-text__p _semibold"
							></div>
							<div class="b-swr-res__tag g-text__p _middle _gray">
								{{ item.sectionName }}
							</div>
						</div>
					</div>
					<div
						v-else-if="searchStart && inputValue"
						class="b-swr-res__container"
					>
						<div class="b-swr-res__item">
							<div class="b-swr-res__title g-text__p _semibold">
								Ничего не найдено
							</div>
							<div class="b-swr-res__tag g-text__p __middle _gray">
								Попробуйте перефразировать запрос
							</div>
						</div>
					</div>
				</template>
			</Transition>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import ShareButton from '../../ui/ShareButton'

export default {
	name: 'GosFaqSearch',
	components: {
		ShareButton,
	},
	props: {
		apiUrl: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			inputValue: '',
			resultsList: [],
			searchStart: false,
			isThrottleStart: false,
			throttleTimer: 800,
			resultChecked: false,
			curItem: null,
		}
	},
	mounted() {},
	methods: {
		throttle(fn) {
			if (this.isThrottleStart) return
			this.isThrottleStart = true

			setTimeout(() => {
				this.isThrottleStart = false
				fn()
			}, this.throttleTimer)
		},
		search() {
			if (!this.inputValue) {
				this.curItem = ''
				this.resultsList = []
				this.searchStart = false
				return
			} else {
				this.curItem = ''
			}

			axios
				.get(
					this.apiUrl,
					{
						params: {
							q: this.inputValue,
						},
					},
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(resp => {
					this.resultsList = resp.data
					this.searchStart = true
				})
				.catch(error => {
					console.error(error)
				})
		},
		showDetailItem(item) {
			this.curItem = item
			this.searchStart = false

			ym(50230510, 'reachGoal', 'podderzhka-click-info', {
				podderzhka_info_name: item.title,
			})
		},
		sendTitleToParent({ title, id }) {
			window.questionId = id
			window.questionTitle = title
		},
		getShareLink(listItem) {
			return `${SERVER_DOMAIN_NAME}/programmy-gosudarstvennoj-podderzhki/faq/${listItem.sectionCode}/${listItem.code}/`
		},
		resetSearch() {
			this.curItem = ''
			this.inputValue = ''
		},
	},
}
</script>
